module.exports = __webpack_public_path__ + "img/thought-bubbles.1cd91764.svg";